import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';
import moment from 'moment';

@Component({
  selector: 'app-contact-bulk-import',
  templateUrl: './contact-bulk-import.component.html',
  styleUrls: ['./contact-bulk-import.component.scss']
})
export class ContactBulkImportComponent {
  fileOver: boolean = false;
  show_table: boolean = false;
  upload_count: any = 0;
  lead_owners: any = []
  @Input() lead_space_id: any = ""
  selectedSheetName: string = '';
  @Input() importStatus: boolean = false;
  @Input() ownerTitle: string = '';

  @Input() displayedColumns?: any = [];
  @Output() handleSubmitData = new EventEmitter<any>();
  @Output("sampleFile") sampleFile: EventEmitter<any> = new EventEmitter();
  @Input() allLeadFeilds: any = [];

  sheetNames: string[] = [];
  columns: string[] = [];
  fields: string[] = ['Field1', 'Field2', 'Field3']; // Add your desired fields here
  workbook: XLSX.WorkBook | null = null;

  mappedColumns: { [key: string]: string } = {}; // Mapping between displayedColumns and Excel columns
  isAdmin: boolean = true; // Example admin flag
  currentUserId: any = "";
  csvData: any = null

  constructor(private localStorage: LocalStorageService, private userApi: UsersService,
    private modalService: NgbModal
  ) {
    this.getAllUsers()
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
    // this.currentUserId = this.localStorage.getUserId()
  }


  ngOnInit() {
    console.log("allLeadFeilds", this.allLeadFeilds)
    this.displayedColumns = this.displayedColumns.filter(
      (column: any) => column !== 'action' && column !== 'info' && column !== 'assign_to'
    );
  }


  private processExcelFile(file: File): void {
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      this.workbook = XLSX.read(bstr, { type: 'binary' });

      // Extract sheet names
      this.sheetNames = this.workbook.SheetNames;
      const worksheet = this.sheetNames[0];
      const jsonData = XLSX.utils.sheet_to_json(this.workbook.Sheets[worksheet], { header: 1 });

      // Extract the first row as column names
      this.columns = (jsonData[0] as string[]) || [];

      this.autoColumnMapping();
    };
    reader.readAsBinaryString(file);
  }

  private processCsvFile(file: File): void {
    Papa.parse(file, {
      complete: (result) => {
        const jsonData = result.data;

        // Extract the first row as column names
        this.columns = (jsonData[0] as string[]) || [];

        // Process the rest of the data as needed
        console.log('CSV Data:', jsonData);

        this.csvData = jsonData;

        this.autoColumnMapping();
      },
      header: false, // Adjust based on whether the CSV file has a header row
    });
  }

  onFileUpload(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const file: File = target.files[0];
    const fileType = file.name.split('.').pop()?.toLowerCase();

    if (fileType === 'xlsx') {
      this.processExcelFile(file);
    } else if (fileType === 'csv') {
      this.processCsvFile(file);
    } else {
      throw new Error('Unsupported file type');
    }
  }

  autoColumnMapping(): void {
    this.displayedColumns.slice(0, this.columns.length).forEach((column: any) => {
      if (column?.key === 'phone') return;
      if (this.columns.includes(column?.value)) {
        this.mappedColumns[column.key] = column?.value
      }
    });

    const hasMobileField = this.displayedColumns.some((column: any) => column?.key === 'mobile');
    if (hasMobileField && !this.mappedColumns['mobile'] && this.columns.includes('Contact Phone')) {
      this.mappedColumns['mobile'] = 'Contact Phone';
    }
  }

  onSheetSelect(event: any): void {
    const selectedSheet = event.target.value;
    this.selectedSheetName = selectedSheet;


    if (this.workbook && selectedSheet) {
      const worksheet = this.workbook.Sheets[selectedSheet];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Extract the first row as column names
      this.columns = (jsonData[0] as string[]) || [];
      this.autoColumnMapping();
    }
  }

  convertColumnName(column: any): string {
    return column.value;
  }

  onSubmit(): void {
    console.log("mappedColumns", this.mappedColumns)
    // Check if a workbook and sheet are selected
    if (!this.sheetNames?.length && !this.csvData) {
      console.error("No workbook, sheet, or CSV data found");
      return;
    }


    let sheetData: any[] = [];

    if (this.workbook) {
      // Handle XLSX file
      const selectedSheetName = this.selectedSheetName || this.sheetNames[0];
      const worksheet = this.workbook.Sheets[selectedSheetName];

      if (!worksheet) {
        console.error("Worksheet not found");
        return;
      }

      // Convert XLSX sheet data to JSON
      sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    } else if (this.csvData) {
      // Handle CSV file
      sheetData = this.csvData;
    }

    // Ensure there is valid sheet data
    if (sheetData.length < 2) {
      console.error("Sheet data is empty or invalid");
      return;
    }

    // Get the header and rows
    const headerRow = sheetData[0]; // First row contains headers
    let dataRows = sheetData.slice(1); // Remaining rows contain data

    console.log("headerRow", headerRow);
    console.log("dataRows", dataRows);

    // remove rows if all columns are empty
    dataRows = dataRows.filter(row => {
      // Keep row if at least one value is not null/empty/whitespace
      return row.some((value:any) => value != null && value.toString().trim() !== '');
    });

    console.log("filteredData", dataRows);


    // Create an array of mapped data objects
    const mappedData = dataRows.map((row) => {
      const mappedRow: any = {};
      Object.keys(this.mappedColumns).forEach((displayedColumn) => {
        const excelColumn = this.mappedColumns[displayedColumn];
        if (excelColumn) {
          // Find the index of the Excel column in the header row
          const columnIndex = headerRow.indexOf(excelColumn);
          if (columnIndex > -1) {
            // Map the Excel column value to the displayed column
            mappedRow[displayedColumn] = row[columnIndex];
            mappedRow['user_id'] = this.localStorage.getUserId();
            mappedRow['contact_owner'] = this.currentUserId == "" ? null : this.currentUserId;
            mappedRow['account_owner'] = this.currentUserId == "" ? null : this.currentUserId;
            mappedRow['client_id'] = this.localStorage.getClientId();
            mappedRow['center_id'] = this.localStorage.getCenterId();
            mappedRow['lead_time'] = moment().format('HH:mm');
            mappedRow['lead_date'] = moment().format('YYYY-MM-DD');

          } else {
            console.warn(`Column "${excelColumn}" not found in header`);
          }
        }
      });
      return mappedRow;
    });


    console.log("mappedData", mappedData);
    let finalData = [];

    if (this.ownerTitle == 'Select Contact Owner') {
      finalData = this.transformContacts(mappedData)
    } else if (this.ownerTitle == 'Select Account Owner') {
      finalData = this.transformAccounts(mappedData)
    }

    console.log("finalData", finalData);
    this.handleSubmitData.emit(finalData);
  }

  transformContacts(contacts: any[]): any[] {
    return contacts.map(contact => {
      const {
        first_name, last_name, email, contact_owner, fax, title, phone, department,
        secondary_email, mobile, address, description, skype_id, lead_source, dob,
        user_id, client_id, center_id, lead_space_id, country_code, lead_time, lead_date, account_owner,
        ...extraFields
      } = contact;

      // If `fields` exists inside contact, extract it, else use `extraFields` directly
      let fields = extraFields.fields || extraFields;

      // Build the address object using fields starting with 'address.'
      const transformedAddress = {
        street: fields['address.street'] || '',
        city: fields['address.city'] || '',
        state: fields['address.state'] || '',
        postal_code: fields['address.postal_code'] || '',
        country: fields['address.country'] || ''
      };

      // Remove all `address.` prefixed fields from `fields`
      const cleanedFields = { ...fields };
      Object.keys(cleanedFields).forEach(key => {
        if (key.startsWith('address.')) {
          delete cleanedFields[key];
        }
      });

      // Remove the contact_owner key if it exists
      delete cleanedFields['contact_owner'];


      const final_object = {
        first_name, last_name, email, contact_owner, fax, title, phone, department,
        secondary_email, mobile, address: transformedAddress, description, skype_id,
        lead_source, dob, user_id, client_id, center_id, lead_space_id, country_code,
        lead_time, lead_date,
        fields: cleanedFields
      };

      return final_object;
    });
  }


  transformAccounts(accounts: any[]): any[] {
    return accounts.map(account => {
      const {
        account_owner, account_site, account_name, status, account_number, email,
        account_type, description, ownership, employees, sic_code, gst_no, tan_no,
        annual_revenue, rating, fax, industry, website, phone_number,
        user_id, client_id, center_id, lead_time, lead_date,
        contact_owner,
        ...extraFields
      } = account;

      // If fields are nested inside `fields`, use them, else use extraFields directly
      let fields = extraFields.fields || extraFields;

      const billing_address = {
        street: fields['billing_address.street'] || '',
        city: fields['billing_address.city'] || '',
        state: fields['billing_address.state'] || '',
        postal_code: fields['billing_address.postal_code'] || '',
        country: fields['billing_address.country'] || ''
      };

      const shipping_address = {
        street: fields['shipping_address.street'] || '',
        city: fields['shipping_address.city'] || '',
        state: fields['shipping_address.state'] || '',
        postal_code: fields['shipping_address.postal_code'] || '',
        country: fields['shipping_address.country'] || ''
      };

      // Remove all billing/shipping prefixed keys from fields
      const cleanedFields = { ...fields };
      Object.keys(cleanedFields).forEach(key => {
        if (key.startsWith('billing_address.') || key.startsWith('shipping_address.')) {
          delete cleanedFields[key];
        }
      });

      delete cleanedFields['contact_owner']; // Remove the contact_owner key if it exists

      const final_object = {
        account_owner, account_site, account_name, status, account_number, email,
        account_type, description, ownership, employees, sic_code, gst_no, tan_no,
        annual_revenue, rating, fax, industry, website, phone_number,
        user_id, client_id, center_id, lead_time, lead_date,
        billing_address,
        shipping_address,
        fields: cleanedFields
      };

      return final_object;
    });
  }


  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.lead_owners = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  handleCloseModel() {
    this.modalService.dismissAll();
  }

  downloadSampleExcel() {
    let col = this.displayedColumns.map((column: any) => this.convertColumnName(column));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    console.log(col)
    XLSX.utils.sheet_add_aoa(ws, [col]);
    XLSX.utils.book_append_sheet(wb, ws, 'Sample Lead');

    XLSX.writeFile(
      wb,
      'sample_data.xlsx'
    );
  }

  toggletable(content: any) {
    this.modalService.open(content, {
      size: 'lg',
      centered: true,

    });
  }

  deactiveTable() {

    if (this.show_table) {
      this.show_table = false;
    }

  }



}